import { render, staticRenderFns } from "./DexHeader.vue?vue&type=template&id=403d497c&scoped=true&"
import script from "./DexHeader.vue?vue&type=script&lang=js&"
export * from "./DexHeader.vue?vue&type=script&lang=js&"
import style0 from "./DexHeader.vue?vue&type=style&index=0&id=403d497c&prod&scoped=true&lang=css&"
import style1 from "./DexHeader.vue?vue&type=style&index=1&id=403d497c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403d497c",
  null
  
)

export default component.exports